/* eslint-disable no-unused-expressions */
/*
 * @Description: H5暴露给原生的接口
 * @Author: fengd
 * @LastEditors: fengd
 * @Date: 2019-03-11 20:16:07
 * @LastEditTime: 2019-09-16 10:45:10
 */

import VConsole from 'vconsole';
import { log } from './EventEmmiter';
import { stepStore } from '../mobx/stores/step';
import RFIDInstance, { CALLBACKS } from './RFID';
import RFBluetoothInstance, { CALLBACKS as bluethCallbacks, NATIVE_CALLBACKS } from './RFBluetooth';
import Toast from '../components/toast/Toast';
import { NATIVE_ERRORS as ERRORS } from './ErrorHandler';
import { parkStore } from '../mobx/stores/park';
import { windowNativeCallback } from './native-interface';
import { upgradeStore } from '../mobx/stores/upgrade';
import { globalStore } from '../mobx/stores/global';
import { signalStore } from '../mobx/stores/signal';
import { broadcastStore } from '../mobx/stores/broadcast';

// 只在开发模式下调试代码，在页面上显示console
// eslint-disable-next-line no-unused-vars
const vconsole = new VConsole();

// 测试阶段，暂时关闭日志上传
if (process.env.NODE_ENV === 'test') {
  log.close();
}

window.RFID = {};
window.RFBluetooth = {};
window.stepStore = stepStore;

Object.values(CALLBACKS).forEach((callback) => {
  window.RFID[`${callback}Callback`] = function (...args) {
    RFIDInstance.emmitCallback(...args);
  };
});

Object.values(bluethCallbacks).forEach((callback) => {
  window.RFBluetooth[`${callback}Callback`] = function (...args) {
    RFBluetoothInstance.emmitCallback(...args);
  };
});

Object.values(NATIVE_CALLBACKS).forEach((callback) => {
  (function (cb) {
    window.RFBluetooth[`${cb}Callback`] = function (...args) {
      if (cb === 'connectBluetooth') {
        globalStore.btOnConnect = true;
      }
      RFBluetoothInstance.emmitCallback(false, ...args);
    };
  }(callback));
});

// 全局原生错误回调
window.errorCallback = (function () {
  let first = true; // 是否是第一次蓝牙出现异常断开
  let time = null; // 第一次异常断开的时间，1分钟内需要一直重试，1分钟后地磁蓝牙会主动关闭

  return function (code) {
    let errorMsg = '';
    let retry = false;

    if (Object.prototype.hasOwnProperty.call(ERRORS, code)) {
      errorMsg = ERRORS[code].description;
      retry = ERRORS[code].retry;
    }

    Toast.fail(errorMsg);

    const error = new Error(errorMsg);
    error.count = 0;
    error.code = code;
    error.originData = code;

    // 停止当前正在执行的任务
    if (RFIDInstance.currentStep) {
      RFIDInstance.emmit(`${RFIDInstance.currentStep}_error`, error);
      // RFIDInstance.endStep();
    }
    if (RFBluetoothInstance.currentStep) {
      RFBluetoothInstance.emmit(`${RFBluetoothInstance.currentStep}_error`, error);
      RFBluetoothInstance.endStep();
    }

    log.postError({
      operate: '异常信息',
      error
    });

    if (first) time = new Date();
    first = false;

    if (globalStore.retryConnectBle && code.indexOf('b') >= 0 && retry && Date.now() - time < 60 * 1000) {
      globalStore.btOnConnect = false;
      RFBluetoothInstance.connectBluetooth()
        .then(() => {
          Toast.success('蓝牙重连成功');
          first = true;
          time = null;

          // 如果在第一步连接蓝牙一直重连，需要跳转下一步
          if (stepStore.step === 1) {
            stepStore.next();
          }
          globalStore.btOnConnect = true;
        })
        .catch(() => {
          Toast.fail('蓝牙重连失败');
          globalStore.btOnConnect = false;
        });
    }
  };
}());

// 蓝牙升级进度回调
window.upgradeProgressCallback = function (progress) {
  upgradeStore.progress = progress;
};

// 蓝牙升级结果回调
window.upgradeResultCallback = function (code) {
  console.log(`蓝牙升级返回结果：${code}`);
  log.postData({
    operate: '蓝牙升级',
    state: code === '0' ? 'default' : 'fail',
    send: '',
    receive: `升级版本：v${upgradeStore.newVersion}；升级花费时间：${upgradeStore.spendTime}`,
    receiveOrigin: '',
    count: 1
  });
  upgradeStore.module = '';
  upgradeStore.progress = '0';
  upgradeStore.status = code === '0' ? 'default' : 'fail';
  upgradeStore.startTime = '';
  upgradeStore.spendTime = '';
  // 地磁升级完成后需要重启，重启过程会持续30s左右，所以先手动修改版本号
  if (code === '0') {
    upgradeStore.version = upgradeStore.newVersion;
  }
};

// 绑定原生接口回调
Object.keys(windowNativeCallback).forEach((key) => {
  window[key] = windowNativeCallback[key];
});

// 拍照录像回调
window.captureCallback = function (path, url) {
  parkStore.addPhoto({ path, url: `data:image/jpg;base64,${decodeURIComponent(url)}` });
};

// 录音回调
window.recordCallback = function (url, duration) {
  parkStore.addAudio({ url, duration });
};

// 录音转文字回调接口
window.voiceToTextCallback = function (code, text) {
  console.log(code, text);
  if (code == '200') {
    parkStore.getAudioTxt(text);
  } else {
    parkStore.getAudioTxt('识别错误，请重新尝试');
  }
};

// 蓝牙信号强度回调（原生定期调用返回 5s）
window.RFBluetooth.remoteRssiCallback = function (rssi) {
  signalStore.bluetooth = rssi;
};

window.RFBluetooth.ScanCallback = function (data) {
  const scanData = typeof data === 'string' ? JSON.parse(data) : data;

  console.log('bluetooth scan: ', scanData);

  // 字段名转换
  broadcastStore.scan({
    ver: scanData.ver,
    cmd: scanData.cmd,
    mac: scanData.mac,
    rssi: scanData.rssi,
    state: parseInt(scanData.space_state, 10),
    radarState: parseInt(scanData.radar_state, 10),
    currentRadarState: parseInt(scanData.cur_radar_state, 10),
    detectTime: scanData.check_time,
    millis: scanData.consume_time,
    receiveTime: scanData.receive_time,
  });
};
